import React, { useState, useEffect } from "react";

/**
 * Stable input component that manages its own state to prevent focus loss
 * during parent component re-renders
 */
const StableInput = ({
  initialValue,
  onSave,
  placeholder,
  type = "text",
  className = "",
  disabled = false,
}) => {
  const [value, setValue] = useState(initialValue || "");

  // Update local state when prop changes (except during typing)
  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  // Handle change only in local state
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  // Only propagate changes on blur
  const handleBlur = () => {
    if (value !== initialValue) {
      onSave(value);
    }
  };

  // Also save on Enter key
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSave(value);
    }
  };

  return (
    <input
      type={type}
      className={`w-full p-2 border border-gray-300 rounded ${className}`}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      autoComplete="off"
      disabled={disabled}
    />
  );
};

export default StableInput;
